// Import model
import { SettingsCondition } from '../models/SettingsCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { SettingsIndexedFields } from '../models/SettingsIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { SettingsIndexedFieldsSerializer } from './SettingsIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for SettingsCondition - handles JSON serialization and deserialization with type validation
 */
export class SettingsConditionSerializer {
  /**
   * Deserializes a JSON string into a SettingsCondition instance
   */
  static deserialize(json: string): SettingsCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a SettingsCondition instance
   */
  static fromObject(obj: any): SettingsCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to SettingsCondition');
    }


    const instance: SettingsCondition = {
      fieldName: obj['fieldName'] as SettingsIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of SettingsCondition instances
   */
  static deserializeArray(json: string): SettingsCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a SettingsCondition instance to a JSON string
   */
  static serialize(instance: SettingsCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a SettingsCondition instance to a plain object
   */
  static toObject(instance: SettingsCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of SettingsCondition instances to a JSON string
   */
  static serializeArray(instances: SettingsCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
